import { useContext } from 'react'

import { useForm } from '@domain-group/react-hooks'

import {
  Button,
  Columns,
  LoadingModule,
  SaveFormModule,
} from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import useAgencySelector from '@hooks/useAgencySelector'
import useUser, { useUserForm } from '@hooks/useUser'

import NotificationBannerLocation from '@components/NotificationBannerLocation'
import NotificationModuleLocation from '@components/NotificationModuleLocation'

import defaultFormState, { requiredFields } from '@models/agent'

import PageLayout from '../../../../components/PageLayout'
import Account from '../Account'
import AgentInformation from '../AgentInformation'
import EBUSettings from '../EBUSettings'
import ExternalLinks from '../ExternalLinks'
import Integrations from '../Integrations'
import UserDetails from '../UserDetails'
import UserImages from '../UserImages'
// import UserTeams from '../UserTeams'

import UserTools from '../../../../components/UserTools'

interface PageContentProps {
  userId: number,
}

const PageContent = (props: PageContentProps) => {
  const { userId } = props

  const pageContext = useContext(PageContext)
  const {
    callbacks: {
      updateUser,
    },
  } = pageContext

  const { selectedAgencyId } = useAgencySelector()

  const userPayload = useUser({ id: userId })

  const {
    callbacks,
    callbacks: {
      updateUser: updateFn,
    },
    isAgent,
    isOfficeAdministrator,
    loading,
    realbaseId,
    updating,
    user,
  } = userPayload

  const userFormPayload = useUserForm(user)
  const { entityState, saveEnabled: userFormSaveEnabled } = userFormPayload

  const agentFormPayload = useForm(defaultFormState, {
    entity: user.actable,
    requiredFields,
    validateOn: 'change',
  }, [user.id, user.cache_key])
  const { entityState: agentState, saveEnabled: agentFormSaveEnabled } = agentFormPayload

  const saveEnabled = userFormSaveEnabled && agentFormSaveEnabled

  const updateUserPayload = {
    callbacks: {
      action: updateFn,
    },
    entityParams: isAgent ? { ...entityState, actable: { ...agentState } } : entityState,
    requestOptions: {
      include_user_type: true,
    },
    toastText: 'User Updated',
  }

  return (
    // @ts-expect-error TS2322
    <PageLayout userPayload={userPayload} activeTabBarItemKey="details" selectedAgencyId={selectedAgencyId}>
      <Columns.Main>
        <NotificationBannerLocation locationKey="agency.agencyManager.editUser.banner" />

        {/*
         // @ts-expect-error TS2322 */}
        <LoadingModule loading={loading} times={3} />

        {!loading && (
          <>
            <UserDetails realbaseId={realbaseId} userFormPayload={userFormPayload} />

            <Account userFormPayload={userFormPayload} />

            {isAgent && (
              <AgentInformation agentFormPayload={agentFormPayload} />
            )}

            <SaveFormModule>
              <Button
                buttonStyle="primaryCreate"
                disabled={!saveEnabled}
                loading={updating}
                // @ts-expect-error TS2322
                marginLeft="auto"
                onClick={() => updateUser(updateUserPayload)}
                size="medium"
              >
                Save Details
              </Button>
            </SaveFormModule>
          </>
        )}
      </Columns.Main>

      <Columns.Sidebar>
        <NotificationModuleLocation locationKey="agency.agencyManager.editUser.sidebar" />

        {isOfficeAdministrator && (
          // @ts-expect-error TS2322
          <EBUSettings callbacks={callbacks} userPayload={userPayload} />
        )}

        <UserTools userPayload={userPayload} />

        <UserImages userId={userId} />

        {/* <UserTeams userId={userId} isAgent={isAgent} /> */}

        {isAgent && (
          <ExternalLinks user={user} />
        )}

        <Integrations userId={userId} />
      </Columns.Sidebar>
    </PageLayout>
  )
}

export default PageContent
